module.exports = __webpack_public_path__ + "media/images/flags/BZ-0f869cac279b47f7fea9a4b182d17fec.svg";